import { render, staticRenderFns } from "./DialogLayer.vue?vue&type=template&id=f2c1e77c&scoped=true"
var script = {}
import style0 from "./DialogLayer.vue?vue&type=style&index=0&id=f2c1e77c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1e77c",
  null
  
)

export default component.exports